/**
 * Settings for the 🐱 candle marker (utils/vestCmeCat.ts), "Vest bar above
 * the CME bar": its section in the Settings > Strategy "Volume markers" tab.
 * Only an on/off switch since #599 (the X% threshold is gone: the rule is the
 * volume pane's own geometry). It writes straight to levelsStore `vestCat`,
 * the same switch as the Levels menu row, so Hide All and Clean cover it.
 */
import React from 'react';
import { useLevelsStore } from '../store/levelsStore';

const RULE_LABEL = 'Vest bar above the CME bar';
const RULE_HINT =
  "Cat when this bar's thin Vest bar visibly sticks out above its CME bar in the volume pane, exactly as the pane is drawn now (either Vest scale). Needs the Vest bars on in the volume pane. Hover shows the raw Vest units vs CME contracts. Closed bars only; no cat when either side has no volume (CME closed, Vest gap). Display only, no alerts.";

export const VestCatSettingsSection: React.FC = () => {
  const enabled = useLevelsStore((s) => !!s.visibility.vestCat);
  const setLevelVisible = useLevelsStore((s) => s.setLevelVisible);
  return (
    <div className="gs-section" data-testid="vest-cat-panel">
      <div className="gs-section-header">
        <span className="gs-section-icon">🐱</span>
        <span className="gs-section-title">{RULE_LABEL}</span>
      </div>
      <div className="gs-row">
        <div className="gs-label">
          <span className="gs-label-main">Show 🐱 on candles</span>
          <span className="gs-label-hint">
            MNQ/NQ charts only. Also in the Levels menu (Volume); Hide All and Clean (Signal markers) cover it. {RULE_HINT}
          </span>
        </div>
        <input
          type="checkbox"
          className="gs-checkbox"
          checked={enabled}
          onChange={(e) => setLevelVisible('vestCat', e.target.checked)}
          aria-label="Show Vest bar above CME bar cat"
          data-testid="vest-cat-enabled"
        />
      </div>
    </div>
  );
};
